export default "__VITE_ASSET__1QpbIjgL__"